import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";


changePasswordActionsStyles.cancelButton = mergeToNew(changePasswordActionsStyles.cancelButton, {
    variant: "secondary",
});